export const maxWidth = {
  name: 'maxWidth',
  label: 'Max Width',
  component: 'number',
  options: ['full', '300', '500','1000', '1445', 'custom'],
};

export const maxHeight = {
  name: 'maxHeight',
  label: 'Max Height',
  component: 'number',
  options: ['full', '1000', '1445', 'custom'],
};

export const width = {
  name: 'width',
  label: 'Width',
  description: 'Put "0" to be auto width',
  component: 'number',
};

export const height = {
  name: 'height',
  label: 'Height',
  description: 'Put "0" to be auto height',
  component: 'number',
};

export const sizeFields = [
  width,
  height,
  maxWidth,
  maxHeight
];

export const size = {
  name: 'size',
  label: 'Size Settings',
  component: 'group',
  fields: sizeFields
};


const paddingFields = [
  {
    name: 'paddingTop',
    label: 'Padding top',
    component: 'number',
    step: 1,
  },
  {
    name: 'paddingRight',
    label: 'Padding right',
    component: 'number',
    step: 1,
  },
  {
    name: 'paddingBottom',
    label: 'Padding bottom',
    component: 'number',
    step: 1,
  },
  {
    name: 'paddingLeft',
    label: 'Padding left',
    component: 'number',
    step: 1,
  }
];


export const padding = {
  name: 'padding',
  label: 'Padding',
  component: 'group',
  fields: paddingFields
};


const marginFields = [
  {
    name: 'marginTop',
    label: 'Margin top',
    component: 'number',
    step: 1,
  },
  {
    name: 'marginRight',
    label: 'Margin right',
    component: 'number',
    step: 1,
  },
  {
    name: 'marginBottom',
    label: 'Margin bottom',
    component: 'number',
    step: 1,
  },
  {
    name: 'marginLeft',
    label: 'Margin left',
    component: 'number',
    step: 1,
  }
];
export const margin = {
  name: 'margin',
  label: 'Margin',
  component: 'group',
  fields: marginFields
};

export const box = {
  name: 'box',
  label: 'Box Settings',
  component: 'group',
  fields: [
    {
      name: '',
      label: '',
      component: 'responsive-group',
      fields: [size, padding, margin]
    }
  ]
};

export const pageBox = {
  name: 'box',
  label: 'Box Settings',
  component: 'group',
  fields: [
    {
      name: '',
      label: '',
      component: 'responsive-group',
      fields: [padding, margin]
    }
  ]
};

